export const NON_LABEL_GROUP_ID = 'empty';
